import styled from 'styled-components';

import { devices } from '@/UI/Styles';
import { applyFlexAndCenter } from '@/styles';
import { Paragraph } from '@/UI/Atoms/Paragraph';

export const Container = styled.footer`
  width: 100%;
  padding: 22px 20px;
  background-color: ${({ theme }) => theme.palette.background};

  @media ${devices['no-mobile']} {
    padding: 28px 0;
  }
`;

export const BoxWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
`;

export const ContentWrapper = styled.div`
  max-width: 800px;
  @media ${devices.XLarge} {
    display: flex;
    justify-content: space-between;
  }
`;

export const LinksWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing[24]};
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  @media ${devices.XLarge} {
    margin-top: 0;
  }
  .companyLink {
    margin-top: ${({ theme }) => theme.spacing[4]};
    text-decoration: underline;
    color: ${({ theme }) => theme.palette.emerald700};
    p {
      color: ${({ theme }) => theme.palette.emerald700};
      font-weight: 500;
    }
    &:hover {
      @media ${devices['no-mobile']} {
        color: ${({ theme }) => theme.palette.primary100};
      }
    }
  }
`;

export const SocialWrapper = styled.div``;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-top: ${({ theme }) => theme.spacing[16]};
  path {
    fill: ${({ theme }) => theme.palette.emerald500};
  }
  a:not(:first-child) {
    margin-left: ${({ theme }) => theme.spacing[16]};
  }
  @media ${devices.XLarge} {
    padding-top: ${({ theme }) => theme.spacing[8]};
  }
`;

export const SocialButton = styled.a`
  text-decoration: none;
  ${applyFlexAndCenter}
`;

export const CopyrightWrapper = styled.div`
  padding-top: ${({ theme }) => theme.spacing[8]};
  padding-bottom: ${({ theme }) => theme.spacing[32]};
  p {
    color: ${({ theme }) => theme.palette.greenDark400};
    font-weight: 500;
  }
  @media ${devices.XLarge} {
    padding-top: ${({ theme }) => theme.spacing[48]};
    padding-bottom: 0;
    ${applyFlexAndCenter}
  }
`;

export const SocialComment = styled(Paragraph)`
  display: none;
  @media ${devices.XLarge} {
    display: flex;
  }
`;
